@if (props.label) {
  <label
    class="section w-100"
    [class.mat-error]="formControl.errors && formControl.touched"
  >
    <span tabindex="0" [innerHTML]="props.label"></span>
    @if (props.required) {
      <sup>*</sup>
    }
    @if (props.help) {
      <span
        matTooltip="{{ props.help }}"
        aria-label="help"
        tabindex="0"
        [matTooltipPosition]="'above'"
        [matTooltipClass]="'rb-tooltip'"
      >
        <mat-icon class="col-1 help-icon"> help </mat-icon>
      </span>
    }
  </label>
}
@if (props.prompt) {
  <p
    class="explanation"
    [class.mat-error]="formControl.errors && formControl.touched"
  >
    <span tabindex="0" [innerHTML]="props.prompt"></span>
    @if (props.required && !to.label && !to.placeholder) {
      <span> *</span>
    }
    @if (props.help && !to.label && !to.placeholder) {
      <span
        matTooltip="{{ props.help }}"
        aria-label="help"
        tabindex="0"
        [matTooltipPosition]="'above'"
        [matTooltipClass]="'rb-tooltip'"
      >
        <mat-icon class="col-1 help-icon"> help </mat-icon>
      </span>
    }
  </p>
}
@if (props.placeholder) {
  <p
    class="italic"
    [class.mat-error]="formControl.errors && formControl.touched"
  >
    <span tabindex="0" [innerHTML]="props.placeholder"></span>
    @if (props.required && !to.label) {
      <span> *</span>
    }
    @if (props.help && !to.label && !to.prompt) {
      <span
        matTooltip="{{ props.help }}"
        aria-label="help"
        tabindex="0"
        [matTooltipPosition]="'above'"
        [matTooltipClass]="'rb-tooltip'"
      >
        <mat-icon class="col-1 help-icon"> help </mat-icon>
      </span>
    }
  </p>
}
<div class="mb-3">
  @if (canUseInputWizard && props?.data?.lookupFileWizard) {
    <div class="operation-flex-container">
      <div class="operation-button-container">
        <button
          type="button"
          class="operation-button"
          mat-raised-button
          color="primary"
          extended
          (click)="
            buttonClicked($event, null, props?.options); $event.preventDefault()
          "
        >
          <span class="button-label">
            <mat-icon>upload_file</mat-icon>
            {{
              rights.includes('Combine5500andDocReader')
                ? 'Document Read and Plan Lookup'
                : 'Select Annuity Source'
            }}
          </span>
        </button>
      </div>
    </div>
  } @else {
    <div class="operation-flex-container">
      @for (opt of props?.options; track $index) {
        @if (opt.value !== '2') {
          <div class="operation-button-container">
            <button
              type="button"
              class="operation-button"
              mat-raised-button
              color="primary"
              extended
              (click)="
                buttonClicked($event, opt.value); $event.preventDefault()
              "
            >
              @if (opt.value === '1') {
                <span class="button-label">
                  <mat-icon>edit_document</mat-icon>
                  {{ opt.label }}
                </span>
              } @else if (opt.value === '3') {
                <span class="button-label">
                  <mat-icon>upload_file</mat-icon>
                  {{ opt.label }}
                </span>
              }
            </button>
          </div>
        } @else if (!!props.buttonType) {
          <div class="operation-button-container">
            <div class="operation-button">
              @if (props.buttonType === 'beacon') {
                <app-annuity-lookup
                  [formlyAttributes]="field"
                  [index]="field.parent.key"
                  [fieldData]="field"
                />
              } @else if (rixtremaButtonTypes.includes(props.buttonType)) {
                <app-rixtrema-lookup
                  [formlyAttributes]="field"
                  [fieldData]="field"
                  [buttonType]="props.buttonType"
                  [type]="props.model.UnitRolloverSettings_ExternalSource"
                />
              } @else if (props.buttonType === 'fundSearch') {
                <app-fund-fee-handler
                  [fieldData]="field"
                  [varSet]="varset"
                  [group]="props.group"
                />
              }
            </div>
          </div>
        }
      }
    </div>
  }
</div>
